export default "__VITE_ASSET__4e2e5772__"